{
  "manager": {
    "upcomingProgramsCard": {
      "upcomingPrograms": "Upcoming Programs",
      "unlockProgramModule": "Unlock the program module to start running programs {'&'} events.",
      "noUpcomingPrograms": "You have no upcoming programs."
    },
    "programInputSearch": {
      "searchPrograms": "Search programs...",
      "selectedProgram": "Selected Program:",
      "showingFirstResults": "Showing first 20 results. Type to search for more.",
      "noProgramsFound": "No programs found for \"{query}\"",
      "removeSelectedProgram": "Remove selected program"
    },
    "cloneProgramModal": {
      "okTitle": "Clone",
      "cloneCountLabel": "Number of clones",
      "cloneCountDescription": "Create up to 24 clones at a time.",
      "adjustDatesLabel": "Automatically adjust registration and event dates",
      "adjustDatesHelp": "Adds one week to the reg. start {'&'} end dates and event start {'&'} end dates.",
      "previewTitle": "Preview",
      "previewTimezoneNote": "Dates shown in your tenant timezone.",
      "noDatesToAdjust": "This registration opportunity does not have dates to adjust.",
      "defaultProgramName": "Registration Opportunity",
      "modalTitle": "Clone {name}",
      "cloneColumn": "Clone",
      "registrationStartColumn": "Registration Start",
      "registrationEndColumn": "Registration End",
      "eventStartColumn": "Event Start",
      "eventEndColumn": "Event End",
      "loadError": "Unable to load registration opportunity details."
    },
    "inputParentProgramTags": {
      "searchOrAddTag": "Search or add a tag",
      "loadTagsError": "Failed to load tags."
    },
    "modalCopyDates": {
      "title": "Copy dates from another opportunity",
      "applying": "Applying...",
      "applyDates": "Apply dates",
      "loadingOpportunities": "Loading opportunities...",
      "noOtherOpportunities": "No other registration opportunities found for this program.",
      "untitled": "Untitled",
      "copyFailedTitle": "Copy failed",
      "copyFailedMessage": "Could not load dates from the selected opportunity.",
      "ongoing": "Ongoing",
      "noDatesSet": "No dates set"
    },
    "modalCopyPricing": {
      "title": "Copy pricing from another opportunity",
      "applying": "Applying…",
      "applyPricing": "Apply pricing",
      "loadingOpportunities": "Loading opportunities…",
      "noOtherOpportunities": "No other registration opportunities found for this program.",
      "untitled": "Untitled",
      "nothingToCopyTitle": "Nothing to copy",
      "nothingToCopyMessage": "\"{name}\" has no pricing set.",
      "copyFailedTitle": "Copy failed",
      "copyFailedMessage": "Could not load pricing from the selected opportunity.",
      "ongoing": "Ongoing",
      "noDatesSet": "No dates set"
    },
    "parentProgramBasicForm": {
      "basicDetails": "Basic Details",
      "typeLabel": "Type *",
      "selectionRequired": "A selection is required.",
      "event": "Event",
      "eventDescription": "- Events issue tickets to participants.",
      "programOrClass": "Program or Class",
      "programDescription": "- Programs are used for activities such as sports registrations.",
      "titleLabel": "Title *",
      "fieldRequired": "This field is required.",
      "titlePlaceholder": "Enter a title",
      "descriptionLabel": "Description",
      "demographicLabel": "Demographic",
      "hostedByLabel": "Hosted By",
      "hostedByDescription": "The instructor or person hosting this program.",
      "tagsLabel": "Tags",
      "additionalRegistrationFeeLabel": "Additional Registration Fee",
      "additionalRegistrationFeeDescription": "Charge an additional amount on-top of the price the user pays specified in the registration opportunity.",
      "capRegistrationFeeDescription": "When enabled, participants will only be charged this fee once per program per cart session. For example, a {'$'}10 fee will be charged once total rather than {'$'}10 per signup.",
      "capRegistrationFeeCheckbox": "Charge registration fee only once per checkout session",
      "allAges": "All Ages",
      "children": "Children (0-12)",
      "youth": "Youth (13-17)",
      "adult": "Adult (18+)",
      "senior": "Senior (55+)",
      "family": "Family"
    },
    "parentProgramCustomFieldsForm": {
      "customFields": "Custom Fields",
      "intro": "Configure custom field values for this program. These fields allow you to track additional program-specific information.",
      "loadingCustomFields": "Loading custom fields...",
      "noCustomFieldsAvailable": "No custom fields available. You can create custom fields in",
      "settings": "Settings",
      "loadError": "Failed to load custom fields",
      "saveError": "Failed to save custom field value"
    },
    "parentProgramFacilitySelect": {
      "calendarBlocking": "Calendar Blocking",
      "blockCalendarsCheckbox": "Block selected facility calendars during {program} dates",
      "setDatesToEnableBlocking": "Set event start and end dates to enable calendar blocking.",
      "blockCalendarsHelp": "When enabled, this {program} will appear on linked facility calendars and prevent double bookings.",
      "schedulingConflictsFound": "Scheduling conflicts found:",
      "existingBookingsCount": "{name}: {count} existing booking(s)",
      "conflictOverlapWarning": "These bookings will overlap with the {program} dates.",
      "linkedFacilities": "Linked Facilities",
      "linkedFacilitiesIntro": "Optionally link this {program} to one or more facilities. This will display facility information to members viewing this {program}.",
      "idLabel": "ID",
      "nameLabel": "Name",
      "linkedLabel": "Linked"
    },
    "parentProgramFileSettingsForm": {
      "fileUploadSettings": "File Upload Settings",
      "allowFileUploadsDescription": "Enable uploads to collect files from registrants across all registration opportunities. Enabling this will not force existing signups to upload a file.",
      "allowFileUploadsCheckbox": "Allow file uploads from registrants",
      "requireFileDescription": "Require at least one file to be uploaded during signup.",
      "requireFileCheckbox": "Require at least one file",
      "maxFilesLabel": "Maximum files per signup",
      "maxFilesDescription": "Set a maximum, or choose No limit.",
      "noLimit": "No limit",
      "unlimitedPlaceholder": "Unlimited"
    },
    "parentProgramFormForm": {
      "formIntegrations": "Form Integrations",
      "intro": "Communal allows you to create custom forms to capture additional information from your users when they are registering for your program or event. You can create a form in Communal",
      "here": "here",
      "selectFromDropdown": "and then select it from the dropdown below. To learn more about this process,",
      "clickHere": "click here",
      "watchVideo": "to watch a step-by-step video.",
      "selectFormLabel": "Select Form",
      "selectFormDescription": "Select a form to use for this program."
    },
    "parentProgramImageForm": {
      "coverImage": "Cover Image",
      "intro": "Upload a custom image or search our image library for one that fits your needs.",
      "uploadImage": "Upload Image",
      "recommendedDimensions": "Recommended dimensions: 800px width by 300px height",
      "imagePreview": "Image Preview",
      "emptyStateHelp": "Upload or select an image by clicking the Upload Image button."
    },
    "parentProgramLocationForm": {
      "location": "Location"
    },
    "parentProgramSettingsForm": {
      "generalSettings": "General Settings",
      "ignoresTaxRatesDescription": "If you have created tax rates then by enabling this setting it will prevent those rates from applying to the price.",
      "ignoresTaxRatesCheckbox": "Exclude this program from tax rates",
      "multipleSignupsDescription": "Users will be allowed to create multiple signups to this program.",
      "multipleSignupsCheckbox": "Allow multiple signups to this event",
      "payByCashDescription": "This creates a payment option on the checkout page that will allow a user signing up to pay by cash in person.",
      "payByCashCheckbox": "Allow payment by cash",
      "familyMemberParticipantDescription": "Allows the user to select from a family member on their account to be the participant. If not selected, the participant will always be the main account holder.",
      "familyMemberParticipantCheckbox": "Allow the user to select a family member as the participant",
      "emergencyContactDescription": "Enabling makes it required for the participant to have a emergency contact information specified.",
      "emergencyContactCheckbox": "Require emergency contact information for participants",
      "differentParticipantDescription": "When enabled, the account holder cannot register themselves. They must select a family member or other participant instead.",
      "differentParticipantCheckbox": "Require registrant to select a different participant",
      "visibility": "Visibility",
      "publicVisibility": "Public Visibility",
      "hideProgramDescription": "When enabled, this program will not appear in the public program directory. Users with a direct link can still view and register for the program.",
      "hideProgramCheckbox": "Hide program from public listings",
      "directProgramLink": "Direct Program Link",
      "shareLinkHelp": "Share this link with users to give them access to this hidden program.",
      "anyoneWithLinkHelp": "Anyone with the link can access the program.",
      "directLinkPlaceholder": "Save the program first to generate the link",
      "copy": "Copy",
      "participantVisibility": "Participant Visibility",
      "showParticipantListDescription": "When enabled, logged-in users can view a list of other participants and the registration opportunity that they registered for. Admins can always see the full participant list regardless of this setting.",
      "showParticipantListCheckbox": "Show participant list to logged-in users",
      "hideEnrollmentDetailsDescription": "When enabled, enrollment counts, participant avatars, spots remaining badges, and 'no one has signed up yet' messages will be hidden from the program page for all viewers.",
      "hideEnrollmentDetailsCheckbox": "Hide enrollment details on program page",
      "autoArchiving": "Auto-Archiving",
      "autoArchiveDescription": "When enabled, registration opportunities under this program will be automatically archived after their event dates have passed.",
      "autoArchiveCheckbox": "Automatically archive registration opportunities after they occur",
      "autoArchiveDaysDescription": "Number of days after the event end date to wait before archiving. Set to 0 to archive the next day.",
      "archiveAfter": "Archive after",
      "days": "days",
      "membership": "Membership",
      "participantMembershipDescription": "When enabled, signups will require the selected participant to hold the membership tied to the chosen price tier.",
      "participantMembershipCheckbox": "Require participant to hold the membership for the selected price",
      "financial": "Financial",
      "glCodeLabel": "GL Code",
      "glCodeDescription": "Override the default GL code for transactions under this program. Leave blank to use the organization default.",
      "glCodePlaceholder": "e.g. 4000-200"
    },
    "parentProgramVolunteeringForm": {
      "associatedVolunteerOpportunities": "Associated Volunteer Opportunities",
      "intro": "Select the volunteer opportunities that are associated with this program. These will be displayed during the registration flow and can be used to create volunteer discounted rates. Note these will only be displayed if the program is set to require registration in the Registration tab.",
      "idLabel": "ID",
      "titleLabel": "Title",
      "associatedLabel": "Associated"
    },
    "parentProgramWaiverForm": {
      "selectWaivers": "Select Waivers",
      "intro": "You may select multiple waivers to be acknowledged by registrants during the registration process. These will only be displayed if the program is set to require registration in the Registration tab."
    },
    "programRecurrenceBuilder": {
      "recurringScheduleTitle": "Recurring Schedule",
      "participantsRegister": "Participants register",
      "once": "once",
      "attendEveryDateInSchedule": "and attend every date in the schedule below.",
      "introDetail": "Best for a class series, weekly group, or any program that meets on a repeating cadence.",
      "repeatLabel": "Repeat",
      "everyLabel": "every",
      "weeksUnit": "weeks",
      "weekUnit": "week",
      "monthsUnit": "months",
      "monthUnit": "month",
      "onLabel": "on",
      "onTheLabel": "on the",
      "pickAtLeastOneDay": "Pick at least one day.",
      "fromLabel": "from",
      "toLabel": "to",
      "startingLabel": "starting",
      "untilLabel": "until",
      "calculatingDates": "Calculating dates…",
      "meetsOn": "Meets on",
      "date": "date",
      "dates": "dates",
      "registersOnceHint": "Each participant registers once for the whole series.",
      "showFewer": "Show fewer",
      "showMore": "Show {count} more",
      "weeklyOption": "weekly",
      "monthlyOption": "monthly",
      "mondayShort": "Mon",
      "tuesdayShort": "Tue",
      "wednesdayShort": "Wed",
      "thursdayShort": "Thu",
      "fridayShort": "Fri",
      "saturdayShort": "Sat",
      "sundayShort": "Sun",
      "dayOfTheMonthOption": "day of the month",
      "weekdayPositionOption": "weekday position",
      "firstOption": "first",
      "secondOption": "second",
      "thirdOption": "third",
      "fourthOption": "fourth",
      "lastOption": "last",
      "aStartDate": "a start date",
      "anEndDate": "an end date",
      "aStartTime": "a start time",
      "anEndTime": "an end time",
      "atLeastOneWeekday": "at least one weekday",
      "adjustRuleHint": "Adjust the rule above to preview dates.",
      "addMissingHint": "Add {missing} to preview dates.",
      "previewFallbackError": "The recurring schedule could not be calculated."
    },
    "programScheduleSummary": {
      "fridays": "Fridays",
      "mondays": "Mondays",
      "saturdays": "Saturdays",
      "sundays": "Sundays",
      "thursdays": "Thursdays",
      "tuesdays": "Tuesdays",
      "wednesdays": "Wednesdays",
      "sessionsCount": "{count} sessions"
    },
    "programScheduleTimeline": {
      "scheduleAriaLabel": "{summary} schedule",
      "sessionCount": "{count} session",
      "sessionsCount": "{count} sessions",
      "hiddenMoreCount": "+ {count} more",
      "nextDates": "Next: {dates}"
    },
    "programsCalendarSubscribeCard": {
      "calendarFeed": "Calendar Feed",
      "intro": "Integrate with external calendars so your users can always see what is going on. Drop this URL on your website, in newsletters, or share it directly — anything that adds it to Google, Apple, or Outlook stays in sync as programs change.",
      "calendarUrl": "Calendar URL",
      "calendarFeedUrl": "Calendar feed URL",
      "copied": "Copied",
      "copyCalendarUrl": "Copy calendar URL",
      "addToAppleCalendar": "Add to Apple Calendar",
      "addToGoogleCalendar": "Add to Google Calendar",
      "addToOutlook": "Add to Outlook"
    },
    "programsWaitlistSettingsCard": {
      "waitlistSettingsTitle": "Waitlist Settings",
      "firstComeFirstServedTitle": "First-Come, First-Served",
      "activeBadge": "Active",
      "fcfsOpenSpots": "Open spots are available to anyone, regardless of their waitlist status.",
      "fcfsWaitlistAdvantage": "The only advantage to being on the waitlist is that you will be notified when a spot opens up.",
      "fcfsLegacyNote": "This is how waitlists worked before the priority waitlist system was introduced.",
      "priorityWaitlistTitle": "Priority Waitlist System",
      "priorityAccess": "Waitlisted users get priority access to open spots before they are made available to the public.",
      "priorityNotifications": "Notifications are sent to waitlisted users one by one at the defined interval below, based on who signed up to the waitlist first. Any user who has been notified of an open spot can sign up, or decline the spot, effectively making it a \"first-come, first-served\" system within the priority waitlist.",
      "notificationIntervalLabel": "Notification Interval",
      "notificationIntervalHelp": "The time between sending notifications to the next person on the waitlist. This setting may be overridden in some cases to ensure there is at least one notified user per spot available to sign up.",
      "staleRemovalLabel": "Stale Waitlist Entry Removal",
      "staleRemovalHelp": "If a user is notified of an open spot and does not accept or decline within this period, they will be removed from the waitlist and notified that they have been removed.",
      "fifteenMinutes": "15 minutes",
      "thirtyMinutes": "30 minutes",
      "oneHour": "1 hour",
      "twoHours": "2 hours",
      "fourHours": "4 hours",
      "eightHours": "8 hours",
      "disabled": "Disabled",
      "twentyFourHours": "24 hours",
      "fortyEightHours": "48 hours",
      "seventyTwoHours": "72 hours",
      "oneWeek": "1 week",
      "loadFailed": "Failed to load waitlist settings",
      "saveSuccess": "Waitlist settings saved",
      "saveFailed": "Failed to save waitlist settings"
    },
    "formProgramOccurrenceList": {
      "eventScheduleTitle": "Event Schedule",
      "date": "date",
      "dates": "dates",
      "participantsRegister": "Participants register",
      "once": "once",
      "attendEveryDateBelow": "and attend every date below.",
      "introDetail": "Add each meeting time the program runs.",
      "noDatesYet": "No dates yet — add the first one to get started.",
      "dateTitle": "Date {number}",
      "removeDateAriaLabel": "Remove date {number}",
      "dateLabel": "Date",
      "startTimeLabel": "Start time",
      "endTimeLabel": "End time",
      "addAnotherDate": "Add another date",
      "missingDate": "Missing date.",
      "missingStartTime": "Missing start time.",
      "missingEndTime": "Missing end time.",
      "endTimeAfterStart": "End time must be after start time.",
      "occurrencesMustNotOverlap": "Occurrences must not overlap.",
      "dateAddedAnnouncement": "Date {number} added",
      "dateRemovedAnnouncementSingular": "Date {number} removed, {count} date remaining",
      "dateRemovedAnnouncementPlural": "Date {number} removed, {count} dates remaining"
    },
    "addProgramSignup": {
      "creating": "Creating",
      "signupsWillExceedTheSignupLimitOf": "signups will exceed the signup limit of",
      "for": "for",
      "youCanStillSubmit": ". You can still submit.",
      "selectRegistrationOpportunityTitle": "1. Select Registration Opportunities",
      "selectOneOrMoreRegistrationOpportunities": "Select one or more registration opportunities",
      "pleaseSelectAtLeastOneRegistrationOpportunity": "Please select at least one registration opportunity",
      "registrationOpportunity": "Registration Opportunity",
      "noRegistrationOpportunitiesFound": "No registration opportunities found",
      "associateAUserTitle": "2. Associate a User",
      "selectRegistrationOpportunityFirst": "Please select a registration opportunity first",
      "whoAreYouRegistering": "Who are you registering?",
      "existingUser": "Existing User",
      "newGuest": "New Guest",
      "searchForSomeoneExisting": "Search for someone already in the system",
      "createRegistrationForSomeoneNew": "Create registration for someone new",
      "findAUser": "Find a User",
      "pleaseSelectAUser": "Please select a user",
      "searchByNameOrEmail": "Search by name or email",
      "selectParticipantTitle": "3. Select Participant",
      "completeUserInformationFirst": "Please complete user information first",
      "customFormAndPaymentDetailsTitle": "4. Custom Form & Payment Details",
      "completeParticipantInformationFirst": "Please complete participant information first",
      "customForm": "Custom Form",
      "paymentInformation": "Payment Information",
      "tickets": "Tickets",
      "amountPaid": "Amount Paid",
      "total": "Total",
      "paymentMethod": "Payment Method *",
      "sendUserEmailNotification": "Send user an email notifying them a program has been signed up for",
      "includeTransactionReceipt": "Include a transaction receipt in email",
      "selectedUser": "Selected user",
      "ongoing": "Ongoing",
      "newGuestPreview": "New Guest: {name} ({email})",
      "existingUserPreview": "Existing User: {name}",
      "participantPreview": "Participant: {name}",
      "participantFamilyMemberPreview": "Participant: {name} (family member)",
      "participantNewFamilyMemberPreview": "Participant: {name} (new family member)",
      "amountViaMethodPreview": "{'$'}{amount} via {method}",
      "errorCreatingSignup": "Error creating signup",
      "customFormStillLoading": "A custom form is still loading. Please wait a moment and try again.",
      "signupsCreatedSuccessfully": "{quantity} signups created successfully",
      "signupCreatedSuccessfully": "{quantity} signup created successfully"
    },
    "deleteOptionConfirmModal": {
      "deleteOption": "Delete Option",
      "optionUsedByProgram": "The option \"{name}\" is used by {count} program.",
      "optionUsedByPrograms": "The option \"{name}\" is used by {count} programs.",
      "deleteWarning": "If you delete this option, the field value will be removed from those programs."
    },
    "programPrice": {
      "pricingModeFor": "Pricing mode for {priceName}",
      "whatDoesRecurringMean": "What does recurring mean?",
      "recurringHelp": "Splits the price into scheduled payments. Configure the number, frequency, and start date using the Schedule action.",
      "priceFor": "Price for {priceName}",
      "maxPurchasesFor": "Max purchases for {priceName}",
      "hideSchedule": "Hide schedule",
      "editSchedule": "Edit schedule",
      "schedule": "Schedule",
      "scheduleNotConfiguredYet": "Schedule not configured yet",
      "startDate": "Start date *",
      "startDateDescription": "First payment runs on or after this date.",
      "numberOfPayments": "Number of payments *",
      "mustBeAtLeastTwoPayments": "Must be at least 2 payments",
      "paymentFrequency": "Payment frequency *",
      "planLabel": "Plan:",
      "planSummaryWeekly": "{count} × {'$'}{amount} weekly, starting {date}",
      "planSummaryMonthly": "{count} × {'$'}{amount} monthly, starting {date}",
      "planTotal": "· {'$'}{total} total",
      "paid": "Paid",
      "free": "Free",
      "recurring": "Recurring",
      "notAbleToRegister": "Not able to register",
      "weekly": "Weekly",
      "monthly": "Monthly"
    },
    "programSignupParticipantForm": {
      "fullName": "Full Name *",
      "nameIsRequired": "Name is required",
      "email": "Email *",
      "emailIsRequired": "Email is required",
      "phoneNumber": "Phone Number *",
      "phoneNumberIsRequired": "Phone number is required",
      "signupForSomeoneElse": "This signup is for someone else.",
      "participant": "Participant",
      "addFamilyMemberLink": "Click here to add a family member not found in the above list.",
      "participantInfo": "Participant Info",
      "signup": "Signup",
      "programSignup": "Program signup"
    },
    "programSignupShow": {
      "downloadBlankForm": "Download Blank Form",
      "participantDetailsHeader": "PARTICIPANT DETAILS",
      "additionalDetailsHeader": "ADDITIONAL DETAILS",
      "modifyParticipantDetails": "Modify Participant Details",
      "paymentDetailsHeader": "PAYMENT DETAILS",
      "transactionDetailsHeader": "TRANSACTION DETAILS",
      "transactionIdLabel": "Transaction ID:",
      "viewTransactions": "View Transactions",
      "volunteerDetailsHeader": "VOLUNTEER DETAILS",
      "volunteerSignupsIntro": "We found the user is associated with the below shift signups for the volunteer opportunities associated with this program.",
      "noVolunteerSignups": "No volunteer signups found associated this signup.",
      "filesHeader": "FILES",
      "fileUploadsDisabled": "File uploads are disabled for this registration opportunity.",
      "downloadAll": "Download All",
      "uploadFile": "Upload File",
      "formResponseHeader": "FORM RESPONSE",
      "noFormsAssociated": "No forms are associated with this program",
      "activityLogHeader": "ACTIVITY LOG",
      "userDetailsTab": "User Details",
      "paymentDetailsTab": "Payment Details",
      "volunteerDetailsTab": "Volunteer Details",
      "formResponseTab": "Form Response",
      "filesTab": "Files",
      "notesTab": "Notes",
      "activityTab": "Activity"
    },
    "renameOptionsConfirmModal": {
      "updateOptionLabels": "Update Option Labels",
      "updateOptions": "Update Options",
      "intro": "You have renamed the following options. Existing program field values will be updated to reflect these changes:",
      "usedByProgram": "(used by {count} program)",
      "usedByPrograms": "(used by {count} programs)"
    },
    "programBaseDetailsForm": {
      "details": "Details",
      "titleLabel": "Title *",
      "signupLimitLabel": "Signup limit",
      "limitInvalidFeedback": "Must be ≤ {availableSpots} available spots",
      "leaveBlankNoLimit": "Leave blank for no limit.",
      "spotsAvailable": "{availableSpots} spots available.",
      "upToPlaceholder": "Up to {availableSpots}",
      "noLimitPlaceholder": "No limit"
    },
    "programPriceForm": {
      "pricing": "Pricing",
      "price": "price",
      "prices": "prices",
      "set": "set",
      "copyFrom": "Copy from…",
      "audience": "Audience",
      "mode": "Mode",
      "explainPricingModes": "Explain pricing modes",
      "pricingMode": "Pricing mode",
      "paidLabel": "Paid",
      "paidDescription": "— One payment for the full amount at checkout.",
      "freeLabel": "Free",
      "freeDescription": "— No charge for this audience.",
      "recurringLabel": "Recurring",
      "recurringDescription": "— Split the total into scheduled payments (set count, frequency, and start date under Schedule).",
      "notAbleToRegisterLabel": "Not able to register",
      "notAbleToRegisterDescription": "— This audience cannot register for the program.",
      "priceHeader": "Price",
      "maxPerUser": "Max per user",
      "planPricing": "Plan pricing",
      "nonMemberPricing": "Non-member pricing",
      "guest": "Guest",
      "volunteer": "Volunteer",
      "pricingCopiedTitle": "Pricing copied",
      "pricingCopiedBody": "Applied pricing from \"{name}\".",
      "untitled": "Untitled"
    },
    "programSettingsForm": {
      "settings": "Settings",
      "hideFromNonBuyersDescription": "Check this box if you want to hide this event registration from users who do not have a specified price. This can be useful if you only want certain users to see and purchase the event.",
      "hideFromNonBuyersLabel": "Hide this registration from users who do not have a price specified",
      "waitlistDescription": "Users will be able to join a waitlist if all spots are taken.",
      "waitlistLabel": "Enable waitlist registration",
      "excludeRemindersDescription": "Prevent reminder emails from being sent to registrants for this registration opportunity.",
      "excludeRemindersLabel": "Exclude from reminder emails",
      "dobValidationDescription": "Define a range of dates that participants must be born between.",
      "dobValidationLabel": "Add date of birth validation",
      "oldestDobLabel": "Oldest date of birth for participant",
      "oldestDobInvalidFeedback": "Must be older than the minimum age.",
      "youngestDobLabel": "Youngest date of birth for participant",
      "youngestDobInvalidFeedback": "Must be less than maximum age.",
      "allowFileUploadsDescription": "Collect files from registrants during signup. Existing signups are not required to upload.",
      "allowFileUploadsLabel": "Allow file uploads at signup",
      "requireFileLabel": "Require at least one file at signup",
      "maxFilesLabel": "Maximum files per signup",
      "noLimit": "No limit",
      "unlimitedPlaceholder": "Unlimited"
    },
    "storeProgramForm": {
      "singleDate": "Single date",
      "multipleDates": "Multiple dates",
      "recurring": "Recurring",
      "ongoing": "Ongoing"
    },
    "modalProgramConflict": {
      "schedulingConflictsDetected": "Scheduling Conflicts Detected",
      "adminOverrideAvailable": "Admin Override Available:",
      "adminOverrideHelp": "You can acknowledge these conflicts and proceed, or cancel to make changes.",
      "conflictWarning": "Enabling facility blocking for this program will overlap with existing bookings, requests, or other blocking programs. Review the conflicts below:",
      "conflictFound": "Conflict Found:",
      "conflictsFound": "Conflicts Found:",
      "unknownFacility": "Unknown Facility",
      "bookingCount": "{count} booking",
      "bookingsCount": "{count} bookings",
      "requestCount": "{count} request",
      "requestsCount": "{count} requests",
      "programCount": "{count} program",
      "programsCount": "{count} programs",
      "proceedWarning": "Proceeding will allow double-booking on the affected facilities during the program dates.",
      "acknowledgeAndContinue": "Acknowledge {'&'} Continue"
    },
    "customProgramFieldCreate": {
      "nameLabel": "Name *",
      "typeLabel": "Type *",
      "allowMultipleSelectionLabel": "Allow Multiple Selection",
      "allowMultipleSelectionHelp": "If checked, users can select multiple options from this field.",
      "optionsHeader": "Options",
      "optionPlaceholder": "Option {number}",
      "usedByProgram": "Used by {count} program",
      "usedByPrograms": "Used by {count} programs",
      "addOption": "Add Option",
      "typeText": "Text",
      "typeSelect": "Select",
      "typeCheckbox": "Checkbox",
      "editFieldHeader": "Edit Field",
      "createFieldHeader": "Create Field",
      "entity": "Program Field",
      "createPageTitle": "Create Custom Program Field",
      "editPageTitle": "Edit Custom Program Field"
    },
    "parentProgramCreate": {
      "backToPrograms": "Back to Programs",
      "editEventHeader": "Edit Event",
      "editProgramHeader": "Edit Program",
      "createEventHeader": "Create Event",
      "createProgramHeader": "Create Program",
      "draft": "Draft",
      "published": "Published",
      "unsaved": "Unsaved",
      "saving": "Saving...",
      "saveAndExit": "Save {'&'} Exit",
      "autoSaving": "Auto-saving...",
      "saved": "Saved",
      "pleaseWaitWhileWeSave": "Please wait while we save your changes",
      "pageTitle": "Create Program",
      "unknown": "Unknown",
      "basicTab": "Basic",
      "locationTab": "Location",
      "imageTab": "Image",
      "fileUploadsTab": "File Uploads",
      "registrationTab": "Registration",
      "waiversTab": "Waivers",
      "volunteeringTab": "Volunteering",
      "formsTab": "Forms",
      "customFieldsTab": "Custom Fields",
      "settingsTab": "Settings"
    },
    "parentProgramIndex": {
      "editRecommendedOrder": "Edit Recommended Order",
      "clearRecommendedOrder": "Clear Recommended Order",
      "saveRecommendedOrder": "Save Recommended Order",
      "title": "Programs {'&'} Events",
      "tagsFilterLabel": "Tags",
      "failedToLoadTagFilterOptions": "Failed to load tag filter options.",
      "failedToLoadItemsForReordering": "Failed to load items for reordering.",
      "recommendedOrderSaved": "Recommended order saved. Members and guests now see this order.",
      "failedToSaveOrder": "Failed to save order.",
      "recommendedOrderCleared": "Recommended order cleared. Members and guests now see automatic date order.",
      "failedToResetOrder": "Failed to reset to natural order."
    },
    "parentProgramShow": {
      "editHeader": "Edit {name}",
      "basicDetails": "Basic Details",
      "location": "Location",
      "openings": "Openings"
    },
    "parentProgramSignupIndex": {
      "backToPrograms": "Back to Programs",
      "viewTransactions": "View transactions",
      "refundedOfTotal": "{amount} refunded of {total}",
      "fullyRefunded": "{amount} fully refunded",
      "viewAllTransactions": "View All Transactions",
      "createSignup": "Create Signup",
      "moveSignup": "Move Signup ({count})",
      "noSignupsFoundFor": "No signups found for",
      "activeOrUpcoming": "active or upcoming",
      "registrationOpportunities": "registration opportunities.",
      "signupFoundInPast": "signup found in past registration opportunities.",
      "signupsFoundInPast": "signups found in past registration opportunities.",
      "showPastSignups": "Show Past Signups",
      "signupsForTitle": "Signups for {title}",
      "signupsTitle": "Signups",
      "ongoing": "Ongoing",
      "activeUpcomingRegOps": "Active {'&'} Upcoming Reg. Ops",
      "pastRegOps": "Past Reg. Ops",
      "allRegOps": "All Reg. Ops",
      "programFilterLabel": "Program",
      "showSignupsForFilterLabel": "Show Signups For",
      "registrationOpportunityFilterLabel": "Registration Opportunity",
      "activeUpcomingOngoingSection": "Active {'&'} Upcoming {'&'} Ongoing",
      "pastSection": "Past",
      "archivedSection": "Archived",
      "adjustFilterToReveal": "Adjust 'Show Signups For' filter to reveal",
      "refundIssuedSuccessfully": "Refund issued successfully.",
      "refundFailed": "Refund failed",
      "unableToIssueRefund": "Unable to issue refund. Please try again.",
      "pageTitle": "View Signups"
    },
    "parentProgramWaitlistIndex": {
      "waitlistForTitle": "Waitlist for {title}",
      "addToWaitlist": "Add to Waitlist",
      "pageTitle": "Waitlist"
    },
    "programRegistrationForm": {
      "registrationSettingsTitle": "Registration Settings",
      "displayOnlyCheckbox": "Display-only: no registration required",
      "displayOnlyDatesHelp": "Display-only {type} have no registration opportunities to roll dates up from. Set the dates shown publicly here.",
      "events": "events",
      "programs": "programs",
      "eventStartDateLabel": "Event Start Date",
      "eventStartTimeLabel": "Event Start Time",
      "eventEndDateLabel": "Event End Date",
      "eventEndTimeLabel": "Event End Time",
      "setSharedCapacity": "Set a shared capacity for this {type}",
      "event": "event",
      "program": "program",
      "totalSpotsInvalidFeedback": "Total spots must be greater than or equal to reserved spots",
      "sharedTotalCapacity": "Shared total capacity",
      "capacityExplanationAriaLabel": "Capacity explanation",
      "capacityExplanation": "Registration opportunities with a signup limit pull from this total as reserved spots. Opportunities without a signup limit draw from whatever remains.",
      "readHelpArticle": "Read the help article →",
      "noLimitPlaceholder": "No limit",
      "reservedChip": "{reserved} of {total} reserved",
      "registrationOpportunitiesTitle": "Registration Opportunities",
      "create": "Create",
      "ongoing": "Ongoing",
      "moreOccurrences": "+ {count} more",
      "backToRegistrationOpportunities": "Back to Registration Opportunities",
      "for": "For",
      "changedElsewhere": "This registration opportunity was changed elsewhere since you opened it. Reload the page and re-apply your changes.",
      "occurrencesInvalid": "Occurrences are invalid.",
      "saveFailed": "Save failed",
      "completeEveryOccurrence": "Complete every occurrence and resolve any overlaps before saving.",
      "registrationOpportunityEntity": "Registration Opportunity",
      "registrationInformationEntity": "Registration information",
      "editRegistrationOpportunity": "Edit Registration Opportunity",
      "createRegistrationOpportunity": "Create Registration Opportunity",
      "cloneSuccess": "Registration opportunities cloned successfully",
      "cloneFailed": "Failed to clone registration opportunities"
    },
    "programSettings": {
      "title": "Program Settings",
      "reminderSettingsTitle": "Reminder Settings",
      "disabling": "Disabling",
      "will": "will",
      "disablingApplies": "also apply to existing program signups. Those members will no longer receive a reminder.",
      "enablingWill": "Enabling will",
      "not": "not",
      "enablingApplies": "apply to existing program signups. Only members who sign up after enabling will receive a reminder.",
      "remindMembers": "Remind members of an upcoming program",
      "whenToRemindLabel": "When to Remind",
      "hoursBefore": "{hours} hours before",
      "settingsEntity": "Settings"
    },
    "programSignupPaymentFields": {
      "amountPaidLabel": "Amount Paid *",
      "paymentMethodLabel": "Payment Method *",
      "sendSignupEmail": "Send user an email notifying them a program has been signed up for",
      "includeReceipt": "Include a transaction receipt in email",
      "amountPaidRequired": "Amount paid is required",
      "amountPaidMinValue": "Amount paid must be 0 or greater",
      "paymentMethodRequired": "Please select a payment method"
    },
    "programSignupSidebar": {
      "viewSignup": "View Signup",
      "createSignup": "Create Signup"
    },
    "customProgramFieldIndex": {
      "title": "Custom Program Fields"
    },
    "programSignupsCreate": {
      "title": "Create Signup"
    },
    "programSignupsEdit": {
      "title": "Edit Signup",
      "fullNameLabel": "Full Name",
      "emailLabel": "Email",
      "phoneNumberLabel": "Phone Number",
      "signupForSomeoneElse": "This signup is for someone else.",
      "participantLabel": "Participant",
      "addFamilyMemberLink": "Click here to add a family member not found in the above list.",
      "participantInfo": "Participant Info",
      "guestInfo": "Guest Info",
      "signup": "Signup",
      "programSignup": "Program signup"
    },
    "waitlistSettings": {
      "title": "Waitlist Settings"
    },
    "modalMoveSignup": {
      "title": "Move Signups",
      "cannotMove": "Cannot Move:",
      "subscriptionWarning": "{count} signup(s) have active recurring payment schedules. Cancel recurring payments before moving.",
      "registration": "registration",
      "selected": "selected",
      "remainingMore": "+ {count} more",
      "transferTo": "Transfer to",
      "loadingDestinations": "Loading destinations...",
      "capacityImpact": "Capacity impact",
      "current": "Current:",
      "full": "Full",
      "spot": "spot",
      "available": "available",
      "noCapacityLimit": "No capacity limit",
      "afterTransfer": "After transfer:",
      "overCapacityBy": "Program will be over capacity by {count} registration",
      "willRemainAvailable": "will remain available after move",
      "alreadyEnrolled": "already enrolled (will be skipped)",
      "overCapacity": "Over capacity",
      "overCapacityWarning": "Proceeding will make this program over capacity.",
      "acknowledgeCapacity": "I understand this will exceed capacity",
      "priceDifferenceNote": "Note: Price differences are not automatically collected or refunded."
    }
  },
  "user": {
    "modalProgramParticipants": {
      "registrationOpportunity": "Registration Opportunity",
      "namesNotAvailable": "Participant names are not available for this program.",
      "participantRegistered": "{count} participant registered",
      "participantsRegistered": "{count} participants registered",
      "noParticipantsYet": "No participants yet.",
      "participant": "{count} participant",
      "participants": "{count} participants",
      "participantsTitle": "Participants",
      "programParticipantsTitle": "Program Participants",
      "all": "All"
    },
    "programListItem": {
      "registrationFee": "+ {fee} fee",
      "nonRefundableFee": "This fee is non-refundable registration fee.",
      "ongoing": "Ongoing",
      "participant": "{count} participant",
      "participants": "{count} participants",
      "noSignupsYet": "No one has signed up yet",
      "full": "Full",
      "canRegisterMoreTime": "You can register {count} more time.",
      "canRegisterMoreTimes": "You can register {count} more times.",
      "waitlistOnly": "Waitlist only",
      "membershipRequired": "Membership Required",
      "unlimited": "Unlimited",
      "registrationClosedAt": "Registration closed {date}.",
      "registrationOpensAt": "Registration opens {date}.",
      "requiresMembership": "Requires {name}",
      "availableWithMemberships": "Available with {memberships}",
      "registered": "Registered",
      "addedToCart": "Added to Cart",
      "registrationNotOpen": "Registration is not open.",
      "register": "Register",
      "registerForFree": "Register for Free",
      "free": "Free",
      "perMonthFor": "per month for {count} months",
      "perWeekFor": "per week for {count} weeks",
      "registrationClosesAt": "Registration closes {date}."
    },
    "programSignupGuestFields": {
      "invalidEmail": "Please enter a valid email address",
      "emailRequired": "Email is required",
      "nameRequired": "Name is required"
    },
    "programSignupHistoryCard": {
      "pastSignups": "Past signups",
      "signupItemLabel": "signup",
      "filterByYear": "Filter by year",
      "searchPlaceholder": "Search past signups…",
      "searchAriaLabel": "Search past signups",
      "loadFailed": "Couldn't load past signups.",
      "tryAgain": "Try again",
      "clearFilters": "Clear filters",
      "cancelled": "Cancelled",
      "allYears": "All years",
      "loadMoreFromYear": "Load more from {year}",
      "loadMoreResults": "Load more results",
      "loadMore": "Load more",
      "noSignupsMatchingQueryInYear": "No past signups matching \"{query}\" in {year}.",
      "noSignupsMatchingQuery": "No past signups matching \"{query}\".",
      "noSignupsInYear": "No past signups in {year}.",
      "noSignupsYet": "No past signups yet."
    },
    "programSignupParticipantPicker": {
      "whoWillParticipate": "Who will be participating in this program?",
      "selectFamilyMember": "Select Family Member",
      "chooseWhoWillParticipate": "Choose who will be participating:",
      "selected": "Selected",
      "select": "Select",
      "noFamilyMembersFound": "No family members found for this user.",
      "dontSeeWhoYoureLookingFor": "Don't see who you're looking for?",
      "addNewFamilyMember": "Add a new family member",
      "createNewFamilyMember": "Create New Family Member",
      "enterNewFamilyMemberDetails": "Enter the details for the new family member:",
      "backToList": "Back to List",
      "selectWhoWillParticipate": "Select who will participate",
      "selectedUser": "Selected user",
      "someoneElse": "Someone else (e.g. family member)"
    },
    "programSignupShowView": {
      "yourSignup": "Your signup",
      "partOf": "Part of",
      "when": "When",
      "location": "Location",
      "registered": "Registered",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "addToCalendar": "Add to calendar",
      "viewProgram": "View program",
      "cancelSignup": "Cancel signup",
      "yourDetails": "Your details",
      "payment": "Payment",
      "method": "Method",
      "filesYouUploaded": "Files you uploaded",
      "seriesDates": "Series · {count} dates",
      "totalPaid": "Total paid",
      "total": "Total"
    },
    "programWaitlistSignupCard": {
      "youHaveWaitlistOffer": "You have a waitlist offer",
      "joined": "Joined {date}",
      "lastNotified": "Last notified {date}",
      "register": "Register",
      "declineOffer": "Decline Offer",
      "declinedOfferHelp": "Having declined this offer, you will need to cancel your waitlist signup and join the waitlist again if you want to receive future offers.",
      "cancelWaitlistSignup": "Cancel waitlist signup",
      "declineWaitlistOfferTitle": "Decline Waitlist Offer",
      "yesDeclineOffer": "Yes, decline offer",
      "cancelWaitlistSignupTitle": "Cancel Waitlist Signup",
      "yesCancelSignup": "Yes, cancel signup",
      "keepSignup": "Keep signup",
      "programFallback": "Program",
      "never": "never",
      "expiresIn": "Expires in {relative} ({absolute})",
      "declineConfirmText": "Are you sure you want to decline this waitlist offer? You will need to cancel your waitlist signup and join the waitlist again if you want to receive future offers.",
      "cancelConfirmText": "Are you sure you want to cancel your waitlist signup? You will be removed from the waitlist and will need to join again if you want to receive future offers.",
      "offerDeclined": "Offer declined",
      "offerDeclinedMessage": "Your waitlist offer has been declined.",
      "removedFromWaitlist": "Removed from waitlist",
      "signupCancelledMessage": "Your waitlist signup has been cancelled."
    },
    "programCustomForm": {
      "additionalDetails": "Additional details"
    },
    "programList": {
      "searchPlaceholder": "Search registration options...",
      "limitedCapacityOptions": "LIMITED CAPACITY OPTIONS",
      "cappedHelpWithTotal": "Each option has its own capacity limit, and all registrations count toward the overall program capacity.",
      "cappedHelp": "Each option has its own capacity limit.",
      "noRegistrationOpportunities": "Sorry, there are currently no registration opportunities available for this program.",
      "generalRegistration": "GENERAL REGISTRATION",
      "uncappedHelpWithTotal": "Uses the remaining capacity from the total program limit minus the spots allocated to limited options.",
      "uncappedHelp": "Open registration without capacity restrictions.",
      "fullBadge": "Full ({limit}/{limit})",
      "spotsRemainingBadge": "{spotsRemaining} spot(s) remaining",
      "unlimitedSpotsBadge": "Unlimited spots available",
      "fullBadgeShort": "Full",
      "spotsAvailableBadge": "{spotsAvailable} spot(s) available"
    },
    "programPromptNumberOfGuests": {
      "numberOfGuests": "Number of Guests",
      "invalidFeedback": "Must be a number zero or greater.",
      "description": "Please specify the number of guests associated with this signup."
    },
    "programSignupPreviewCard": {
      "noLocation": "No location",
      "confirmCancellation": "Confirm Cancellation"
    },
    "programVolunteerOpportunitySignup": {
      "wouldYouLikeToVolunteer": "Would you like to register as a volunteer?",
      "costReducedTo": "Your registration cost will be reduced to",
      "ifYouSignupAsVolunteer": "if you signup as a volunteer for one of the below opportunities.",
      "change": "Change",
      "selectWhoWillBeVolunteering": "Select who will be volunteering:"
    },
    "waitlistButton": {
      "youreOnTheWaitlist": "You're on the waitlist!",
      "wellNotify": "We'll notify",
      "whenYourSpotOpens": "when your spot in the waitlist opens up.",
      "whenASpotOpens": "when a spot opens up.",
      "removeFromWaitlist": "Remove from waitlist",
      "joinWaitlist": "Join Waitlist",
      "enterEmailToBeNotified": "Enter your email to be notified when there are open spots",
      "enterYourEmailPlaceholder": "Enter your email",
      "waitlistSignupEntity": "Waitlist signup",
      "waitlistJoined": "Waitlist joined!"
    },
    "parentProgramIndex": {
      "tags": "Tags",
      "calendar": "Calendar"
    },
    "parentProgramShow": {
      "programNotFound": "Program Not Found",
      "programNotFoundMessage": "The program you're looking for doesn't exist or is not available.",
      "browseAllPrograms": "Browse All Programs",
      "categories": "Categories",
      "offerInvalid": "The priority waitlist offer link you used is invalid, expired, or has already been used. Normal registration and waitlist rules apply.",
      "offerValidButFull": "Your waitlist offer is valid, but the program is currently full. Please check back in the future as spots may become available.",
      "activeMembersSaveUpTo": "Active members save up to",
      "login": "Login",
      "or": "or",
      "purchaseAMembership": "purchase a membership",
      "toReceiveTheDiscount": "to receive the discount.",
      "viewProgram": "View Program",
      "checkOutThisProgram": "Check out this program",
      "event": "Event",
      "allAges": "All Ages",
      "children": "Children (0-12)",
      "youth": "Youth (13-17)",
      "adult": "Adult (18+)",
      "senior": "Senior (55+)",
      "family": "Family",
      "registrationFee": "Registration Fee",
      "registrationFeeDescription": "A one-time non-refundable registration fee charged by {tenantName}"
    },
    "programSignupIndex": {
      "mySignups": "My Signups",
      "upcoming": "Upcoming",
      "upNext": "Up next",
      "viewSignup": "View signup",
      "confirmCancellation": "Confirm cancellation",
      "cancelSignup": "Cancel signup",
      "ongoing": "Ongoing",
      "pass": "pass",
      "active": "Active",
      "signup": "Signup"
    },
    "programSignupShow": {
      "signupDoesNotExist": "This signup does not exist.",
      "backToMySignups": "Back to My Signups",
      "yourProgramSignup": "Your Program Signup",
      "signupCancelled": "Signup cancelled.",
      "cancelSignupFailed": "Failed to cancel signup. Please try again."
    },
    "programWaitlistIndex": {
      "myWaitlistSignups": "My Waitlist Signups",
      "notOnAnyWaitlists": "You are not currently on any waitlists. Browse available programs to join a waitlist when spots are full.",
      "myWaitlists": "My Waitlists",
      "loadError": "We were unable to load your waitlist signups. Please try again."
    },
    "volunteerSignup": {
      "heading": "Would you like to register as a volunteer?",
      "costReductionPrefix": "Your registration cost will be reduced to",
      "costReductionSuffix": "if you signup as a volunteer for one of the below opportunities.",
      "selectOption": "Please select an option",
      "change": "Change",
      "selectVolunteer": "Select who will be volunteering:"
    },
    "formMemberParticipantInformation": {
      "informationVisibleWarning": "The selected participant's first name and last initial will be visible on the participant list to logged in users.",
      "noEligibleMembers": "No eligible members found. A matching membership is required.",
      "selectYourself": "Select yourself",
      "selected": "Selected",
      "you": "(You)",
      "born": "Born:",
      "noMatchingMembership": "No matching membership.",
      "dontHoldMembership": "You do not hold the required membership.",
      "dobRequiredTitle": "Date of birth required.",
      "enterBirthDate": "Please enter your birth date to register for this program.",
      "notEligibleBirthDate": "Not eligible due to birth date.",
      "birthDateMustBe": "Birth date must be {range}.",
      "addBirthDate": "Add Birth Date",
      "editBirthDate": "Edit Birth Date",
      "updateYourBirthDate": "Update Your Birth Date",
      "dateOfBirthRequired": "Date of Birth *",
      "eligibleBirthDateHint": "To be eligible, birth date must be {range}.",
      "saving": "Saving...",
      "saveAndContinue": "Save & Continue",
      "selectOrganization": "Select an organization",
      "selectFamilyMember": "Select a family member",
      "emergency": "Emergency:",
      "participantInformation": "Participant Information",
      "nameRequired": "Name *",
      "email": "Email",
      "phone": "Phone",
      "dateOfBirth": "Date of Birth",
      "emergencyInfo": "Emergency Info",
      "emergencyContactName": "Emergency Contact Name",
      "emergencyContactPhone": "Emergency Contact Phone",
      "saveChanges": "Save Changes",
      "addFamilyMember": "Add Family Member",
      "ineligibleFamilyMembers": "Ineligible family members",
      "ineligibleMembershipIntro": "The following family members do not have the required membership. You can add or manage memberships from the",
      "myMemberships": "My Memberships",
      "pageSuffix": "page.",
      "participantsBirthDateEligible": "Participants must have a birth date {range} to be eligible.",
      "needsMembershipVisit": "This family member needs a required membership. Visit My Memberships to add one.",
      "updateBirthDate": "Update Birth Date",
      "otherInformation": "Other Information"
    }
  },
  "guest": {
    "parentProgramIndex": {
      "tags": "Tags",
      "calendar": "Calendar"
    },
    "formGuestParticipantInformation": {
      "participantVisibilityWarning": "The selected participant's first name and last initial will be visible on the participant list to logged in users.",
      "copyFromPreviousStep": "Copy Information from Previous Step",
      "basicInformation": "Basic Information",
      "nameLabel": "Name *",
      "nameFeedback": "Please enter a name",
      "namePlaceholder": "Enter full name",
      "emailLabel": "Email *",
      "emailFeedback": "Please enter a valid email address",
      "emailPlaceholder": "Enter email address",
      "dateOfBirthLabel": "Date of Birth *",
      "dateOfBirthFeedback": "Please enter a valid date of birth",
      "dateOfBirthPlaceholder": "Select date of birth",
      "phoneLabel": "Phone",
      "phonePlaceholder": "Enter phone number",
      "emergencyContactInformation": "Emergency Contact Information",
      "emergencyContactNameLabelRequired": "Emergency Contact Name *",
      "emergencyContactNameLabel": "Emergency Contact Name",
      "emergencyContactNameFeedback": "Please enter an emergency contact name",
      "emergencyContactNamePlaceholder": "Enter emergency contact name",
      "emergencyContactPhoneLabelRequired": "Emergency Contact Phone *",
      "emergencyContactPhoneLabel": "Emergency Contact Phone",
      "emergencyContactPhoneFeedback": "Please enter a valid phone number",
      "emergencyContactPhonePlaceholder": "Enter emergency contact phone"
    }
  }
}
